import type { FC } from "react";
import React from "react";
import translate from "src/lib/translate";
import BloodPressureForm from "src/ui/components/BloodPressureForm/BloodPressureForm";
import InDialog from "src/ui/components/InDialog/InDialog";
import useGoToOrBack from "src/ui/hooks/useGoToOrBack";
import { AppQueryPopupsController } from "../AppQueryPopups/AppQueryPopupsBloc";
import { LoincCodingCode } from "src/constants/fhir";
import { globalEvents } from "src/constants/globalEvents";

const BloodPressureDialog: FC<{
  returnUrl: string;
}> = ({ returnUrl }) => {
  const navigate = useGoToOrBack();

  const onClose = (dispatch?: boolean) => {
    AppQueryPopupsController.closePopup();
    if (dispatch) {
      document.dispatchEvent(
        new CustomEvent(globalEvents.DATA_SUBMITTED, {
          bubbles: true,
          detail: { loincCode: LoincCodingCode.bloodPressure }
        })
      );
    }
    navigate(returnUrl, {
      multiBack: true,
      replace: true
    });
  };

  return (
    <InDialog
      popup
      title={translate("upload_labs.title")}
      returnUrl={returnUrl}
      onClose={onClose}
    >
      <nine-spacer s="md"></nine-spacer>

      <BloodPressureForm onComplete={() => onClose(true)} />
    </InDialog>
  );
};

export default BloodPressureDialog;
